<template>
    <b-modal id="createModal" ref="modal" title="Create a Chemical Target" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Chemical Target Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import createChemicalTargetMutation from '@views/ChemicalTargets/CreateModal/mutationCreateChemicalTarget.graphql';

export default {
  name: 'create-modal',
  apollo: {},
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: '',
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        const input = { name: this.name };

        this.$apollo
          .mutate({
            mutation: createChemicalTargetMutation,
            variables: {
              input,
            },
          })
          .then(() => {
            this.$emit('refresh');
            this.$notifySuccess('Chemical target created!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
